const developmentHosts = new Set([
  'console.stage.ocplanet.cloud',
  'console-dev.ocplanet.cloud',
  'ocp-front-dev.netengi.com',
])

export const isProdEnvironment = process.env.NODE_ENV === 'production'
  && !developmentHosts.has(window.location.hostname)
